<template>
  <div>
    <div class="row">
      <div class="col_12">
          <div class="card no_border">
            <div class="card-header">
                <div class="card-title">강의영상</div>
            </div>
            <div class="card-body pl_0 pr_0">
              <div class="row">
                <div class="col_2">
                  <div class="form-group ">
                    <label>상태</label>
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                          <button class="btn">
                            <span>{{ filter2.convert_status }}</span>
                          </button>
                          <div class="dropdown_menu">
                            <ul>
                              <li @click="changeStatusFilter('all')"><a role="button">{{ $t('common.all') }}</a></li>
                              <li @click="changeStatusFilter('Pending')"><a role="button">Pending</a></li>
                              <li @click="changeStatusFilter('Completed')"><a role="button">Completed</a></li>
                              <li @click="changeStatusFilter('Others')"><a role="button">Others</a></li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_2">
                  <div class="form-group ">
                    <label>강의형</label>
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                          <button class="btn">
                            <span>{{ filter2.lecture_type }}</span>
                          </button>
                          <div class="dropdown_menu">
                            <ul>
                              <li @click="changeLectureTypeFilter('all')"><a role="button">{{ $t('common.all') }}</a></li>
                              <li @click="changeLectureTypeFilter('course_learning')"><a role="button">{{ $t('sidebar.courseLearning.courseLearning') }}</a></li>
                              <li @click="changeLectureTypeFilter('thinking_skill')"><a role="button">{{ $t('sidebar.thinkingSkill.thinkingSkill') }}</a></li>
                              <li @click="changeLectureTypeFilter('special_lecture')"><a role="button">특강</a></li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_2">
                  <div class="form-group ">
                      <label>{{ $t('common.grade') }}</label>
                      <div class="d_flex_start">
                          <div class="dropdown custom_dropdown mr_10">
                              <button class="btn">
                                  <span>{{ filter2.grade }}</span>
                              </button>
                              <div class="dropdown_menu">
                                  <ul>
                                      <li><a role="button" @click="changeGradeFilter('all')">{{ $t('common.all') }}</a></li>
                                      <li v-for="grade in grades" :key="'grade '+grade.id">
                                          <a role="button" @click="changeGradeFilter(grade)">{{ grade.name }}</a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="col_2">
                    <div class="form-group ">
                        <label>{{ $t('sidebar.semesters.semesters') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.semester }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeSemesterFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="semester in semesters" :key="'semester '+semester.id">
                                            <a role="button" @click="changeSemesterFilter(semester)">{{ semester.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_4">
                  <div class="form-group ">
                    <label></label>
                    <div class="d_flex_end">
                      <div class="form_row_inline ml_10">
                        <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                      </div>
                      <div class="form_row_inline ml_10">
                        <div class="btn btn_common_type_2 width_150p" @click="queryParams.page = 1 ; searchQuery()">{{ $t('common.search') }}</div>
                      </div>
                      <div class="form_row_inline ml_10">
                        <div class="btn btn_common_type_2 width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col_12 ">
                      <div class="separator pl_0 pr_0">
                          <span></span>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col_12">
                    <div class="d_flex_btwn pt_20 pb_20">
                        <div class="d_flex_start col_2 pl_0">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter.per_page }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                      <li @click="changeFilter(10)"><a role="button">10</a></li>
                                      <li @click="changeFilter(20)"><a role="button">20</a></li>
                                      <li @click="changeFilter(50)"><a role="button">50</a></li>
                                      <li @click="changeFilter(100)"><a role="button">100</a></li>
                                      <li @click="changeFilter(200)"><a role="button">200</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <table-component 
                  :columns="columns"
                  :rows="orders"
                  :pagination="pagination"
                  @sorting="sorting"
                  :sortable="sortable"
                  @pageChanged="pageChanged">
                  <template #lecture_type="{ row }">
                      <div v-if="row.course_learning_id">{{ $t('sidebar.courseLearning.courseLearning') }}</div>
                      <div v-if="row.special_lecture_id">특강</div>
                      <div v-if="row.thinking_skill_id">{{ $t('sidebar.thinkingSkill.thinkingSkill') }}</div>
                  </template>
                  <template #lecture_type_grade="{ row }">
                      <div v-if="row.course_learning">{{ row.course_learning.grade ? row.course_learning.grade.name : '' }}</div>
                      <div v-if="row.special_lecture">{{ row.special_lecture.grade ? row.special_lecture.grade.name : '' }}</div>
                      <div v-if="row.thinking_skill">{{ row.thinking_skill.grade ? row.thinking_skill.grade.name : '' }}</div>
                  </template>
                  <template #lecture_type_semester="{ row }">
                    <div v-if="row.course_learning">{{ row.course_learning.semester ? row.course_learning.semester.name : '' }}</div>
                    <div v-if="row.special_lecture">{{ row.special_lecture.semester ? row.special_lecture.semester.name : '' }}</div>
                    <div v-if="row.thinking_skill">{{ row.thinking_skill.semester ? row.thinking_skill.semester.name : '' }}</div>
                  </template>
              </table-component>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";
export default {
  components: {TableComponent},
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      orders: [],
      grades: [],
      semesters: [],
      filter: {
        grade: '',
        semester: '',
        convert_status: '',
        lecture_type: '',
        per_page: 20
      },
      filter2: {
        lecture_type: this.$t('common.all'),
        convert_status: this.$t('common.all'),
        grade: this.$t('common.all'),
        semester: this.$t('common.all'),
        per_page: 20
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'convert_status',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: this.$t('common.created_at'),
          field: "created_at",
          sortable: true
        },
        {
          label: '강의형',
          field: "lecture_type",
          sortable: false,
          slot: true
        },
        {
          label: this.$t('common.grade'),
          field: "lecture_type_grade",
          sortable: false,
          slot: true
        },
        {
          label: this.$t('common.semester'),
          field: "lecture_type_semester",
          sortable: false,
          slot: true
        },
        {
          label: '상태',
          field: "convert_status",
          sortable: false
        },
      ],
      showRefundConfirmationModal: false,
      packageRefundAmount: '',
      packageOrderId: ''
    }
  },
  watch: {
    $route(to, from) {
        if(to.name == from.name && !window._.isEqual(to, from)){
          this.setQueryData(this.getAllQueryParams())
          this.loadData()
        }
      },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }

    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);

    this.loadData();
  },
  methods: {
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        grade: query.grade,
        semester: query.semester,
        lecture_type: query.lecture_type,
        convert_status: query.convert_status,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    resetAll(){
      this.sortable = {
          order: 'created_at',
          sort: 'desc'
      }
      this.filter = {
        grade: '',
        semester: '',
        convert_status: '',
        lecture_type: '',
        per_page: 20
      }
      this.filter2 = {
        lecture_type: this.$t('common.all'),
        grade: this.$t('common.all'),
        semester: this.$t('common.all'),
        convert_status: this.$t('common.all'),
        per_page: 20
      }

      this.queryParams = {
          page: 1,
          search: '',
          search_columns: 'convert_status',
          sort: 'created_at',
          sort_order: 'desc',
          per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery(){
        this.changeRoute();
    },
    sorting({column, order}) {
        this.queryParams.sort = column;
        this.queryParams.sort_order = order;
        this.queryParams.page = 1;
        this.changeRoute()
    },
    pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
    },
    changeStatusFilter(status){
      if(status == 'all'){
        this.filter.convert_status = ''
        this.filter2.convert_status = this.$t('common.all')
      }else{
        let statusName = '';

        if(status == 'Pending'){
          statusName = 'Pending'
        }else if(status == 'Completed'){
          statusName = 'Completed'
        }else if(status == 'Others'){
          statusName = 'Others'
        }
        this.filter.convert_status = status
        this.filter2.convert_status = statusName
      }
      this.changeRoute();
    },
    changeLectureTypeFilter(lecture_type){
      if(lecture_type == 'all'){
        this.filter.lecture_type = ''
        this.filter2.lecture_type = this.$t('common.all')
      }else{
        let lectureTypeName = '';

        if(lecture_type == 'course_learning'){
          lectureTypeName = this.$t('sidebar.courseLearning.courseLearning')
        }else if(lecture_type == 'thinking_skill'){
          lectureTypeName = this.$t('sidebar.thinkingSkill.thinkingSkill')
        }else if(lecture_type == 'special_lecture'){
          lectureTypeName = '특강'
        }
        this.filter.lecture_type = lecture_type
        this.filter2.lecture_type = lectureTypeName
      }
      this.changeRoute();
    },
    changeGradeFilter(grade) {
        if (grade == 'all') {
            this.filter.grade = ''
            this.filter2.grade = this.$t('common.all')
        } else {
            this.filter.grade = grade.id
            this.filter2.grade = grade.name
        }
        this.changeRoute();
    },
    changeSemesterFilter(semester) {
        if (semester == 'all') {
            this.filter.semester = ''
            this.filter2.semester = this.$t('common.all')
        } else {
            this.filter.semester = semester.id
            this.filter2.semester = semester.name
        }
        this.changeRoute();
    },
    changeFilter(per_page){
      this.filter.per_page = per_page
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/get-lecture-video-conversions', {
            params: {...this.queryParams, ...this.filter}
        }).then((response) => {
            this.orders = response.data.data;
            this.pagination = response.data.meta;
        })
    },
  }
}
</script>